module.exports = __webpack_public_path__ + "media/images/icons/pink_back-9cf178f14067e74a83bc22362c1404c1.svg";